import { type ServicepointInputValue } from './ServicepointInputValue.js'

export const toServicepointLabel = (inputValue: ServicepointInputValue): string => {
  switch (inputValue.inputKind) {
    case 'PackStation':
      return `${inputValue.servicepoint.name} (# ${inputValue.postNumber})`
    case 'Servicepoint':
      return inputValue.servicepoint.name
    default:
      return ''
  }
}
